var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var V = function V(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 13 10' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'v'
      ),
      React.createElement('path', { d: 'M1 5l3.898 4.084L12.186 0', stroke: 'currentColor', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round' })
    )
  );
};
/*eslint-enable */

export default V;
//# sourceMappingURL=V.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/V.js